import transform from 'lodash-es/transform';
import { WorksheetActionModelSelector } from '@autoinformer/helpers/worksheets/action-types';
export class Base {
  constructor(item) {
    this.id = item.id || null;
    this.type = item.type || '';
    this.name = item.name || '';
    this.position_x = item.position_x || 0;
    this.position_y = item.position_y || 0;
    // this.position_x = 550 || 0;
    // this.position_y = 120 || 0;
    this.data = item.data || { params: {}, options: {} };
  }

  toBaseFrontend() {
    const source = Object.assign({}, this);
    return transform(source, function (result, value, key) {
      if (key === 'position_x' || key === 'position_y') {
        const [prefix, coords_name] = key.split('_');
        const prev_position = result[prefix] || {};
        result[prefix] = { ...prev_position, [coords_name]: value };
      } else {
        result[key] = value;
      }
    });
  }

  toFrontend() {
    return WorksheetActionModelSelector.getFrontendModelByType(this.type, this.toBaseFrontend());
  }

  getData() {
    return this.data;
  }

  getPosition() {
    return {
      position_x: this.position_x,
      position_y: this.position_y
    };
  }
}
